import React from 'react'

import Offer from './Offer'
import ViewToggle from '../../subcomponents/ViewToggle'
import { FootnotesFromContext } from "../../subcomponents/Footnotes";

const OfferBannerSpend = props => {
    return (
        <ViewToggle isMobile={props.isMobile('web')}>
            <Offer {...props} campaign={props.campaign}
                   image={props.isMobile('web') ? props.campaign.image_1_1 : props.image}
                   className={'banner ' + props.type} />
            <FootnotesFromContext
                showWarningText={props.footnotesWarningText}
                bigIndices={props.bigIndices}
            />
        </ViewToggle>
    )

}

export default OfferBannerSpend



// WEBPACK FOOTER //
// ./src/components/ads/mam3/OfferBannerSpend.js